import { ColumnsStructure } from '@/contracts/data/TableContracts'

// Return available columns:
function getColumns(): ColumnsStructure
{
    return {
        'hmctsgrant:surname':
        {
            label: 'Last name',
            type: 'string'
        },
        'hmctsgrant:firstnames':
        {
            label: 'First name',
            type: 'string'
        },
        'hmctsgrant:dateofdeath':
        {
            label: 'Date of death',
            type: 'date'
        },
        'hmctsgrant:dateofprobate':
        {
            label: 'Date of probate',
            type: 'date'
        },
        'hmctsgrant:probatenumber':
        {
            label: 'Probate number',
            type: 'string'
        },
        'hmctsgrant:grantdocTypeoOfName':
        {
            label: 'Document type',
            type: 'string'
        },
        'hmctsgrant:registryofficename':
        {
            label: 'Registry office',
            type: 'string'
        },
        'hmctsgrant:regimentnumber':
        {
            label: 'Regiment number',
            type: 'string'
        }
    } as ColumnsStructure
}
// Prepare columns based on grant type:
export function prepareTableColumns(grantType: number): ColumnsStructure
{
    // Get columns:
    let columns = getColumns()
    // Set allowed columns:
    let allowed = [] as string[]
    // Switch grant type to determine columns to return:
    switch(grantType)
    {
        case 1:
            allowed =
            [
                'hmctsgrant:surname',
                'hmctsgrant:firstnames',
                'hmctsgrant:dateofdeath',
                'hmctsgrant:dateofprobate',
                'hmctsgrant:probatenumber',
                'hmctsgrant:grantdocTypeoOfName',
                'hmctsgrant:registryofficename'
            ]
            columns = Object.fromEntries(
                Object.entries(columns).filter(([key]) => allowed.includes(key))
            ) as ColumnsStructure
            break
        case 3:
            allowed =
            [
                'hmctsgrant:surname',
                'hmctsgrant:firstnames',
                'hmctsgrant:dateofdeath',
                'hmctsgrant:regimentnumber'
            ]
            columns = Object.fromEntries(
                Object.entries(columns).filter(([key]) => allowed.includes(key))
            ) as ColumnsStructure
            break
    }
    return columns
}
// Prepare columns for orders:
export function prepareOrderTableColumns(): ColumnsStructure
{
    // Get columns:
    let columns = getColumns()
    // Set allowed columns:
    let allowed = [] as string[]
    // Switch grant type to determine columns to return:
    allowed =
    [
        'hmctsgrant:surname',
        'hmctsgrant:firstnames',
        'hmctsgrant:dateofdeath'
    ]
    columns = Object.fromEntries(
        Object.entries(columns).filter(([key]) => allowed.includes(key))
    ) as ColumnsStructure
    return columns
}
// Format column value:
export function getFormattedColumnValue(value: string, type: string): string
{
    switch(type)
    {
        case 'date':
            return getFriendlyDate(value)
        default:
            return value
    }
}

// Set month names:
const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December']
// Format friendly date string
function getFriendlyDate(dateString: string): string
{
    if(!dateString)
    {
        return ''
    }
    const d = new Date(dateString)
    return d.getUTCDate() + ' ' + monthNames[d.getUTCMonth()] + ' ' + d.getUTCFullYear()
}
